import { useState, useEffect } from "react";
import { Typography, TextField, Button, List, ListItem, IconButton, ListSubheader } from "@mui/material";
import API from "../../../api";
import { btnStyle } from "../../../theme";
import ClearIcon from '@mui/icons-material/Clear';
import { startToast, updateToastSuccess, updateToastError } from '../../../utils/notification-loading';


const OptionsAutorizations = ({mainUser}) => {
  const [users, setUsers] = useState([]);
  const [newAccount, setNewAccount] = useState([]);

  const refreshAccountData = () => {
    if (!mainUser?.email) {
      return;
    }
    
    API.getSecondaryAccount().then(response => {
      
      const updatedUsers = response.data.map((user) => {
        const account = user.accounts.find((account) => account.email === mainUser.email);
        
        let userType = 'unknown';
        if (account) {
          userType = account.type;
        } else {
          const isAdmin = user.accounts.some(acc => acc.email === mainUser.email && acc.type === 'admin');
          userType = isAdmin ? 'admin' : 'unknown';
        }
        
        return {
          ...user,
          type: userType
        }
      })
      setUsers(updatedUsers);
    }).catch(error => {
      console.error('Error refreshing secondary accounts:', error);
    });
  };

  useEffect(() => {
    refreshAccountData();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refreshAccountData is redefined every render; adding it here would run the effect on every render instead of only when mainUser?.email changes
  }, [mainUser?.email]);


  const handleAddAccount = (matricola, email) => {
    startToast()
    if(validateEmail(email)){
      API.addAccount({ email: email, serial_number: matricola }).then(response => {
        updateToastSuccess("Secondary account added successfully!");
        // Ricarica i dati invece di ricaricare la pagina
        refreshAccountData();
        // Pulisci il campo di input
        const lecsIndex = users.findIndex(user => user.matricola === matricola);
        if (lecsIndex !== -1) {
          const newAccounts = [...newAccount];
          newAccounts[lecsIndex] = '';
          setNewAccount(newAccounts);
        }
      }).catch(error => {
        console.error(error)
        if (error.response.status === 401) {
          updateToastError("Your account is not authorized for this operation");
        } else {
          updateToastError("Error while adding the secondary account, check that the selected LECS is not already among the authorized ones");
        }
      })
    }else{
      updateToastError("Your email is not valid");
    }
  }


  const handleDeleteAccount = (matricola, user) => {
    startToast()
    API.deleteUser({ matricola: matricola, user: user }).then((result) => {
      if(result.data === "ok"){
        updateToastSuccess("Account removed successfully!");
        // Ricarica i dati invece di ricaricare la pagina
        refreshAccountData();
      }else{
        updateToastError("You can not remove this account");
      }
    }).catch((err) => {
      updateToastError("Error while removing the account");
    });
  }


  const handleChangeNewAccount = (index, event) => {
    const updatedAccount = [...newAccount];
    updatedAccount[index] = event.target.value;
    setNewAccount(updatedAccount);
  }

  const validateEmail = (email) => {
    const regex = /^[a-z0-9.]+@[a-z0-9]+(\.[a-z0-9]+)+$/;
    return regex.test(email);
  };

  const listStyle = {
    headerItem: {
      backgroundColor: "#449095",
    },
    item: {
      backgroundColor: "#1e1e1e",
      borderBottom: "solid 1px #5e5e5e",
      justifyContent: "space-between",
      py: 2
    }
  }

  return (
    <List sx={{ height: "100%", overflow: "auto"}}>
      {users.length > 0 ? users.map((item, index) => (
        <>
          <ListSubheader sx={listStyle.headerItem} disableSticky>
            {`Serial Number: ${item.matricola}`}
          </ListSubheader>
          {item.accounts.map((user, index) => (
            <ListItem sx={listStyle.item}>
                <Typography variant="body1">
                  Email: <span style={{fontWeight: 300}}>{user.email}</span> &nbsp;&nbsp; Type: <span style={{fontWeight: 300}}>{user.type === "admin" ? "primary" : "secondary"}</span>
                </Typography>
              {user.email !== mainUser?.email && item.type && item.type === "admin" && (
                <IconButton color="error" onClick={() => handleDeleteAccount(item.matricola, user)}>
                  <ClearIcon fontSize="small"/>
                </IconButton>
              )}
            </ListItem>
          ))}
          {item.type && item.type === "admin" && (
            <ListItem sx={listStyle.item}>
              <TextField 
                size="small" 
                placeholder="Email"
                value={newAccount[index]}
                onChange={(e) => handleChangeNewAccount(index, e)}
                sx={{mr:2, width: 300}}/>
                <Button sx={{...btnStyle}} onClick={() => handleAddAccount(item.matricola, newAccount[index])}>Add Account</Button>
            </ListItem>
          )}
        </>
      )) : (
        <ListItem>
          <Typography >No accounts found</Typography>
        </ListItem>
      )}
    </List>
  );

};

export default OptionsAutorizations;